import cx from "classnames";

// CSS
import styles from "./section.module.scss";

const Section = (props) => {
    const { children, classes, config, id, style } = props;
    const { darkMode } = config || {};

    return (
        <div
            className={cx(styles.section, classes, {
                [styles["section--dark"]]: darkMode,
            })}
            id={id}
            style={style}
        >
            {children}
        </div>
    );
};

export default Section;
